import {memo} from 'react';
import {Toaster} from 'sonner';

const ProcessToast = memo(() => (
  <Toaster position="bottom-right" duration={5000} visibleToasts={5} richColors />
));

export {ProcessToast};
